import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../../../Constant/constants';
import { useParams, useNavigate } from 'react-router-dom';

const EditMedicine = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    unitPrice: '',
    expiryDate: '',
    manufacturer: '',
  });

  useEffect(() => {
    fetchMedicine();
  }, []);

  const fetchMedicine = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.get(`${API_PATH}/medicines/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFormData(res.data);
    } catch (error) {
      console.error('Failed to fetch medicine:', error);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('authToken');
    try {
      await axios.patch(`${API_PATH}/medicines/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('✅ Medicine updated!');
      navigate('/admin/home/medicines/list');
    } catch (error) {
      console.error('Update failed:', error);
      alert('❌ Update failed');
    }
  };

  return (
    <div className="container mt-4">
      <h3>Edit Medicine</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name</label>
          <input name="name" value={formData.name} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Description</label>
          <input name="description" value={formData.description} onChange={handleChange} className="form-control" />
        </div>
        <div className="mb-3">
          <label>Unit Price</label>
          <input name="unitPrice" type="number" step="0.01" value={formData.unitPrice} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Expiry Date</label>
          <input name="expiryDate" type="date" value={formData.expiryDate} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Manufacturer</label>
          <input name="manufacturer" value={formData.manufacturer} onChange={handleChange} className="form-control" required />
        </div>
        <button className="btn btn-primary">Update</button>
      </form>
    </div>
  );
};

export default EditMedicine;
